import { store } from "../../Components/store/store";

/**
 * Creates standardized API headers with X-Browser-Id
 * @param token - Optional token, will use Redux store if not provided
 * @param contentType - Content type header, defaults to application/json
 * @returns Headers object for API requests
 */
export const createApiHeaders = (token?: string, contentType: string = "application/json"): any => {
    const authToken = token || store.getState().data.login.value.token;

    return {
        "Content-Type": contentType,
        "Accept": "application/json",
        "Authorization": authToken ? `Bearer ${authToken}` : '',
        "Access-Control-Allow-Origin": "*",
        "X-Browser-Id": "client_H6C2q86BqhICuaQ6naZFzV2qUfodAnLN"
    };
};

/**
 * Creates headers for non-authenticated requests
 * @param contentType - Content type header, defaults to application/json
 * @returns Headers object for public API requests
 */
export const createPublicApiHeaders = (contentType: string = "application/json"): any => {
    return {
        "Content-Type": contentType,
        "Accept": "application/json",
        "Access-Control-Allow-Origin": "*",
        "X-Browser-Id": "client_H6C2q86BqhICuaQ6naZFzV2qUfodAnLN"
    };
};